/* eslint-disable @typescript-eslint/no-explicit-any */
import RouteGuard from "@app/config/RouteGuard";
import { routes } from "@app/config/Routes";
import STORAGE_KEYS from "@src/constants/storageKeys";
import useLocalStorage from "@src/hooks/useLocalStorage";
import { useRolePermissionStore } from "@src/store/PermissionStore";
import { Route, Routes } from "react-router-dom";

const AppRoutes = () => {
      const { get } = useLocalStorage();
      const getRolePermission = useRolePermissionStore((s) => s.rolePermission);
      // const isAuthenticated = () => {
      //       return !!get(STORAGE_KEYS.auth_details);
      // };

      const isAuthenticated = (requiredPermissions: any, allPermissions: any, isProtected: boolean): boolean => {
            if (!isProtected) return true;
            if (isProtected) {
                  if (requiredPermissions) {
                        return requiredPermissions.every((item: any) => {
                              const [module, keys] = Object.entries(item)[0];
                              const pluralModule = module.endsWith("s") ? module : module + "s";
                              const modulePermissions = allPermissions[pluralModule] || allPermissions[module];

                              if (!modulePermissions) return false;

                              if (!Array.isArray(keys)) return false;
                              return keys.every((key: string) => !!modulePermissions[key]);
                        });
                  } else {
                        return !!get(STORAGE_KEYS.auth_details);
                  }
            }
            return false;
      }
      const renderRoutes = (routesArray: any[]) =>
            routesArray.map(({ path, index, element, protected: isProtected, children, allowedRoles }) =>
                  isProtected ? (
                        <Route
                              key={path || element}
                              element={<RouteGuard canActivate={() => isAuthenticated(allowedRoles, getRolePermission?.permissions, isProtected)} allowedRoles={allowedRoles} />}
                        >
                              <Route
                                    path={path}
                                    index={index}
                                    element={element}
                              >
                                    {children && renderRoutes(children)}
                              </Route>
                        </Route>
                  ) : (
                        <Route
                              key={path || element}
                              path={path}
                              index={index}
                              element={element}
                        >
                              {children && renderRoutes(children)}
                        </Route>
                  )
            );

      return <Routes>{renderRoutes(routes)}</Routes>;
};

export default AppRoutes;
